const QRCODE_IMAGE_ENUM = {
  WECHAT: require("./images/wechat_qrcode.png"),
  ALIPAY: require("./images/alipay_qrcode.png"),
};

const SOURCE_ENUM = {
  WECHAT: "wechat",
  ALIPAY: "alipay",
}

export default {
  name: "qrcode",
  data () {
    return {
      qrcode: "",
      sourceName: "",
    };
  },

  created () {
    let type = this.$route.params.type || SOURCE_ENUM.WECHAT;
    if(type == SOURCE_ENUM.WECHAT) {
      this.qrcode = QRCODE_IMAGE_ENUM.WECHAT;
      this.sourceName = "微信";
    } else {
      this.qrcode = QRCODE_IMAGE_ENUM.ALIPAY;
      this.sourceName = "支付宝";
    }
  }
}
